<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <!-- <h4>{{ Object.entries(this.data).length === 0 ? $t("Add New") : $t("Update") }}</h4> -->
      <h4>
        {{ Object.entries(this.data).length === 0 ? "Add New" : "Update Item" }}
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component
      :is="scrollbarTag"
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <!-- Product Image -->
        <template v-if="dataImg">
          <!-- Image Container -->
          <div
            class="img-container w-64 mx-auto flex items-center justify-center"
          >
            <img :src="''" alt="img" class="responsive" />
          </div>

          <!-- Image upload Buttons -->
          <div class="modify-img flex justify-between mt-5">
            <input
              type="file"
              class="hidden"
              ref="updateImgInput"
              @change="updateCurrImg"
              accept="image/*"
            />
            <vs-button
              class="mr-4"
              type="flat"
              @click="$refs.updateImgInput.click()"
              >{{ "Update Image" }}</vs-button
            >
            <vs-button type="flat" color="#999" @click="null">{{
              "Remove Image"
            }}</vs-button>
          </div>
        </template>

        <!-- name -->
        <vs-input
          label="Topic"
          v-model="dataName"
          class="mt-5 w-full"
          name="name"
        />
        <!-- <span
          class="text-danger text-sm"
          v-show="errors.has('name')"
        >{{ 'boy'}}</span> -->

        <vs-input
          :label="'Detail'"
          v-model="dataDetail"
          class="mt-5 w-full"
          name="detail"
        />
        <br />
        <v-select
          class="w-full"
          name="Select"
          placeholder="Type"
          label="text"
          v-model="dataType"
          :options="feather_type"
          :reduce="(feather_type) => feather_type.value"
        />
        <div class="upload-img mt-5" v-if="!dataImg">
          <input
            type="file"
            class="hidden"
            ref="uploadImgInput"
            @change="updateCurrImg"
            accept="image/*"
          />
          <vs-button @click="$refs.uploadImgInput.click()">{{
            "Upload Image"
          }}</vs-button>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData">{{
        dataId ? "Save" : "Add New"
      }}</vs-button>
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >{{ "Cancel" }}</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
  },
  data() {
    return {
      dataId: null,
      dataImg: "",
      dataName: "",
      dataDetail: "",
      dataStatus: "",
      dataKey: "",
      dataPublic: "",
      dataPin: "",
      dataType: "",
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      feather_type: [
        { text: "No login required", value: false },
        { text: "Login required", value: true },
      ],
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    // isFormValid() {
    //   return !this.errors.any() && this.dataName;
    // },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        // this.$validator.reset();
      } else {
        let {
          uid,
          name,
          detail,
          key,
          status,
          pin,
          statusPublic,
          type,
        } = JSON.parse(JSON.stringify(this.data));
        this.dataId = uid;
        this.dataName = name;
        this.dataDetail = detail;
        this.dataKey = key;
        this.dataStatus = status;
        this.dataPublic = statusPublic;
        this.dataPin = pin;
        this.dataType = type;
        this.initValues();
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.datafirstName, this.dataOrder_status, this.dataType } = JSON.parse(JSON.stringify(this.data))
    },
  },
  methods: {
    submitData() {
      if (this.dataId !== null) {
        const obj = {
          name: this.dataName,
          detail: this.dataDetail,
          uid: this.dataId,
          pin: this.dataPin,
          key: this.dataKey,
          statusPublic: this.dataPublic,
          status: this.dataStatus,
          type: this.dataType,
        };
        this.$vs.loading();
        this.$store
          .dispatch("poll/UpdateData", obj)
          .then((res) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Edit Success",
              text: res,
              iconPack: "feather",
              icon: "icon-check",
              color: "success",
            });
            this.$emit("closeSidebar");
          })
          .catch((err) => {
            this.$vs.loading.close();
          });
      } else {
        const obj = {
          name: this.dataName,
          detail: this.dataDetail,
          type: this.dataType,
          uid: this.$store.state.AppActiveUser.uid,
        };
        this.$vs.loading();
        this.$store
          .dispatch("poll/saveValue", obj)
          .then((res) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Upload Success",
              text: res,
              iconPack: "feather",
              icon: "icon-check",
              color: "success",
            });
            this.$emit("closeSidebar");
          })
          .catch((err) => {
            this.$vs.loading.close();
            console.log(err);
          });
      }
    },
    initValues() {
      if (this.data.uid) return;
      this.dataId = null;
      this.dataKey = "";
      this.dataImg = "";
      this.dataName = "";
      this.dataDetail = "";
      this.dataStatus = "";
      this.dataType = "";
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        // var reader = new FileReader();
        // reader.onload = (e) => {
        //   this.$vs.loading();
        const obj = {
          uid: this.$store.state.AppActiveUser.uid,
          file: input.target.files[0],
        };
        this.$store.dispatch("poll/uploadImage", obj);
        //   .then((resp) => {
        //     this.$vs.loading.close();
        //     this.dataImg = resp.data.url;
        //   })
        //   .catch((err) => {
        //     this.$vs.loading.close();
        //     console.error(err);
        //   });
        //   };
        //   reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
